module.exports = __webpack_public_path__ + "static/kartchen4-95e2d4e59e2bd8c930568a71aec8f9aa.png";